export default function VidroTipos() {
  return (
    <section className="py-16 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
            TECNOLOGIA DO VIDRO
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 leading-tight">
            Vidro Temperado vs Vidro Laminado
          </h2>
          <p className="text-stone-500 mt-3 text-sm max-w-xl mx-auto">
            Entenda qual tecnologia é mais adequada para cada aplicação no seu projeto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          {/* Temperado */}
          <div className="relative bg-stone-800 rounded-2xl overflow-hidden p-8 flex flex-col justify-between min-h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=tempered%20glass%20panel%20close%20up%20texture%20transparent%20strong%20modern%20architecture%20detail%20premium%20quality%20material&width=800&height=560&seq=temp001&orientation=landscape"
              alt="Vidro temperado"
              className="absolute inset-0 w-full h-full object-cover object-top opacity-20"
              loading="lazy"
              decoding="async"
            />
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-4">
                <span className="text-amber-400 text-xs font-bold uppercase tracking-widest">Vidro Temperado</span>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </div>
              </div>
              <p className="text-5xl font-bold text-white mb-2">5x</p>
              <p className="text-white/70 text-sm mb-5">mais resistente que o vidro comum</p>
              <ul className="space-y-2">
                {[
                  'Resistência a impactos e variações térmicas',
                  'Ao quebrar, fragmenta em pequenos pedaços arredondados (mais seguro)',
                  'Ideal para fechamento de sacadas articuladas',
                  'Leveza e transparência máxima',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-white/80 text-sm">
                    <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-amber-400 text-sm"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Laminado */}
          <div className="relative bg-stone-700 rounded-2xl overflow-hidden p-8 flex flex-col justify-between min-h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=laminated%20safety%20glass%20panel%20layers%20PVB%20interlayer%20close%20up%20detail%20modern%20building%20facade%20premium%20architectural%20glass%20material&width=800&height=560&seq=lam001&orientation=landscape"
              alt="Vidro laminado"
              className="absolute inset-0 w-full h-full object-cover object-top opacity-20"
              loading="lazy"
              decoding="async"
            />
            <div className="relative z-10">
              <div className="flex items-center justify-between mb-4">
                <span className="text-green-400 text-xs font-bold uppercase tracking-widest">Vidro Laminado</span>
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 text-white">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </div>
              </div>
              <p className="text-5xl font-bold text-white mb-2">2x</p>
              <p className="text-white/70 text-sm mb-5">camadas unidas por película PVB</p>
              <ul className="space-y-2">
                {[
                  'Ao quebrar, os fragmentos ficam presos na película (não cai)',
                  'Maior segurança em guarda-corpos e tetos',
                  'Excelente isolamento acústico',
                  'Indicado para áreas de alto risco de impacto',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-2 text-white/80 text-sm">
                    <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-green-400 text-sm"></i>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* NBR 7199 */}
        <div className="bg-stone-900 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-6">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-500/20 text-amber-400 shrink-0">
            <i className="ri-shield-star-line text-3xl"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <div className="flex flex-wrap items-center gap-3 justify-center md:justify-start mb-2">
              <h3 className="text-white text-xl font-bold">Segurança em Guarda-corpos e Tetos de Vidro</h3>
              <span className="bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">NBR 7199</span>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Todos os nossos projetos de guarda-corpos e tetos de vidro seguem rigorosamente a{' '}
              <strong className="text-white">NBR 7199</strong> — norma técnica brasileira que regulamenta o uso de vidros em edificações. Isso garante que sua instalação está em conformidade com os padrões de segurança exigidos por lei, protegendo você, sua família e seu patrimônio.
            </p>
          </div>
          <div className="shrink-0">
            <span className="inline-block border border-amber-500/50 text-amber-400 text-xs font-bold px-4 py-2 rounded-full uppercase tracking-widest whitespace-nowrap">
              NORMA TÉCNICA GARANTIDA
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
